// extracted by mini-css-extract-plugin
export var filterIncDec = "_aj-0";
export var leftBorder = "_aj-1";
export var rightBorder = "_aj-2";
export var stringInput = "_aj-3";